/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const InfoIcon: React.SFC<any> = (props: any) => {
    return (
        <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
            <title>Form button / info</title>
            <g transform="translate(-2 -2)" fill="none" fillRule="evenodd">
                <circle stroke={props.color ? props.color : `#4F73AF`} cx="11.5" cy="11.5" r="9" />
                <path fill={props.color ? props.color : `#4F73AF`} d="M11 14v-1c-.008-.253.05-.398 0-1 .506-.02.627-.142 1 0v-1c.377.188.522.03 1 0-.248-.316-.19-.536 0-1-.19-.172-.312-.466-1-1-.885-.01-1.202.11-1 0-.68.602-.817.9-1 1H9c.048-.203.147-.5 0-1 .448-.03.637-.253 1 0 .09-.62.35-.76 1-1-.063.048.25 0 1 0-.083 0 .228.046 1 0-.192.23.063.366 0 1 .508-.274.683-.052 1 0-.063.477 0 .782 0 1 0 .372-.028.586 0 1-.415.42-.536.56-1 1-.302.222-.437.34-1 0 .34.546.254.65 0 1 .026.245.012.406 0 1h-1zm1 1.5c0 .128-.047.246 0 .5-.236-.05-.356 0-.5 0-.14 0-.257-.05-.5 0 .05-.248 0-.364 0-.5 0-.134.047-.252 0-.5.236.05.356 0 .5 0 .144 0 .264.048.5 0-.047.242 0 .36 0 .5z" />
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Info/Info.tsx